import { createContext } from 'react'
import type { FlightSearchWidgetDispatchAction } from './flightSearchWidgetStateReducer'
import noop from 'lib/function/noop'

const FlightSearchWidgetDispatchContext = createContext<React.Dispatch<FlightSearchWidgetDispatchAction>>(noop)

export default FlightSearchWidgetDispatchContext
